import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import I18n from 'I18n';
import BasicI18nSetup from 'I18n/init/setup/BasicI18nSetup';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import lang from 'i2l?query=sporks!../../../lang/en.lyaml';
import ErrorPage from './ErrorPage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AppLoadErrorPage = () => {
  // @ts-expect-error dependency missing types
  const [i18nLoaded, setI18nLoaded] = useState(() => Boolean(I18n.locale));
  const {
    portal,
    user
  } = useSelector(state => state.auth) || {};
  useEffect(() => {
    // @ts-expect-error dependency missing types
    if (!I18n.locale && portal && user) {
      BasicI18nSetup.setup({
        lang,
        portal,
        user
      }).then(() => setI18nLoaded(true)).catch(() => {});
    }
  }, [portal, user]);
  if (!i18nLoaded) {
    return null;
  }
  return /*#__PURE__*/_jsxs(ErrorPage, {
    "data-test-id": "app-load-error-page",
    navMarkerName: "APP_LOAD_ERROR",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "app.error.appLoad.title"
    }),
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "app.error.appLoad.description"
    }), /*#__PURE__*/_jsx(Link, {
      onClick: () => window.location.reload(),
      paddingInlineStart: "100",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.error.appLoad.button"
      })
    })]
  });
};
export default AppLoadErrorPage;